import { createFileRoute } from '@tanstack/react-router';
import { MovementForm } from '@/pages/accounts/form-movement';
import { PROTECTED, ACCOUNTS } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${ACCOUNTS}`;

export const Route = createFileRoute(
  '/protected/_layout/accounts/_layout/movements/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditMovementModal,
});

function EditMovementModal() {
  const { id } = Route.useParams();
  return <MovementForm id={id} returnUrl={RETURN_URL} />;
}
